import { render } from "./LearnSection.vue?vue&type=template&id=07506c7b"
import script from "./LearnSection.vue?vue&type=script&lang=js"
export * from "./LearnSection.vue?vue&type=script&lang=js"
script.render = render

export default script